export const PASSWORD_RECOVERY_MODAL_DATA = {
  title: 'Password Recovery',
  subtitle: 'enter a\u00A0new password to\u00A0restore\u00A0access',
} as const;

export const AUTH_MODAL_DATA = {
  title: 'Sign\u00A0up or sign\u00A0in',
  subtitleOnChallenge: 'to create a debate challenge',
  subtitleOnOpponent: 'to accept this debate challenge',
  tabSignUp: 'Sign up',
  tabSignIn: 'Sign in',
} as const;

export const CREATE_DEBATE_MODAL_DATA = {
  title: 'Start your debate',
} as const;

export const CHANGE_PASSWORD_MODAL_DATA = {
  title: 'Create a new password',
} as const;

export const RESTORE_PASSWORD_MODAL_DATA = {
  title: 'Password Recovery',
  subtitle1: 'we will email you a\u00A0link to\u00A0recover your\u00A0password',
  subtitle2: 'your password recovery link has\u00A0been sent to\u00A0',
} as const;

export const CONFIRM_EMAIL_MODAL_DATA = {
  title: 'Confirm email',
  subtitle: 'your email confirmation link has been sent to\u00A0',
} as const;

export const LOGIN_MODAL_DATA = {
  titleAfterRegistration: 'Email confirmed',
  titleAfterRestorePassword: 'Your password has been recovered successfully',
  subtitle: 'sign in to continue',
} as const;

export const STREAM_ENDING = {
  finished: 'This debate has ended',
  left: 'This debate has ended. One of the\u00A0opponents left the\u00A0debate',
  failed: 'This debate was canceled because someone didn\u0027t show up for the\u00A0debate',
} as const;

export const LINK_EXPLANATION = {
  text: 'No confirmation link? Check your spam folder or',
  button: 'request a new link',
} as const;

export const DIALOG_INITIATOR_CANCEL_DEBATE = {
  title: 'Cancel this debate?',
  text: 'You and your opponent will not be able to participate.',
  сonsentText: 'Cancel debate',
  dissentText: 'Go back',
} as const;

export const DIALOG_OPPONENT_CANCEL_DEBATE = {
  title: 'Quit this debate?',
  text: 'You will withdraw from this debate and will not be able to rejoin.',
  сonsentText: 'Quit debate',
  dissentText: 'Go back',
} as const;

export const DIALOG_CANCEL_CHALLENGE = {
  title: 'Cancel this challenge? ',
  text: 'You will not be able to undo this action.',
  сonsentText: 'Cancel challenge',
  dissentText: 'Go back',
} as const;

export const DIALOG_END_DEBATE = {
  title: 'End this debate?',
  text: 'You will withdraw from this debate and will not be able to rejoin.',
  сonsentText: 'End debate',
  dissentText: 'Go back',
} as const;

export const DIALOG_SING_OUT = {
  title: 'Signing out?',
  text: 'You will not be able to create challenges or participate in debates.',
  сonsentText: 'Sign out',
  dissentText: 'Stay signed in',
} as const;

export const DIALOG_CONFIRMATION = {
  title: 'Confirmation',
  text: 'Are you sure you want to exit to another page?',
  сonsentText: 'Yes',
  dissentText: 'Go back',
} as const;

export const DIALOG_CAMERA_CONTROL = {
  title: 'Camera control',
  text: '',
  сonsentText: 'Approve',
  dissentText: 'Decline',
} as const;
